module.exports = __webpack_public_path__ + "img/ali-screens-2.d4d9d844.svg";